
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/about",
      function () {
        return require("private-next-pages/ru/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/about"])
      });
    }
  